import CustomerHeadquarter from "./CustomerHeadquarter";

export default class EConomicData {
	customerId: number;
	customerGroupId: number;
	paymentTermsId: number;
	vatZoneId: number;
	layoutId: number;
	customerHeadquarter: CustomerHeadquarter;

	public isEqual(economicData: EConomicData): boolean {
		return economicData !== null &&
			this.customerGroupId === economicData.customerGroupId &&
			this.paymentTermsId === economicData.paymentTermsId &&
			this.vatZoneId === economicData.vatZoneId &&
			this.layoutId === economicData.layoutId &&
			((this.customerHeadquarter && this.customerHeadquarter.isEqual(economicData.customerHeadquarter)) || this.customerHeadquarter === null);
	}
}
